<template>
  <label :class="['custom-control', switchMode ? 'custom-switch' : 'custom-checkbox']">
    <input
      v-bind="$attrs"
      type="checkbox"
      class="custom-control-input"
      :name="group?.name.value || name"
      :value="value"
      :checked="checked"
      @change="onChange"
    />
    <span class="custom-control-label"><slot></slot></span>
  </label>
</template>
<script lang="ts">
import { computed, defineComponent, inject } from 'vue'
import { checkboxGroupKey } from './checkbox-context'
export default defineComponent({
  name: 'BFormCheckbox',
  inheritAttrs: false,
  props: {
    modelValue: { default: undefined },
    value: { default: true },
    name: { type: String, default: '' },
    switch: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const group = inject(checkboxGroupKey, null)
    const checked = computed(() =>
      group
        ? group.model.value.includes(props.value)
        : Array.isArray(props.modelValue)
          ? props.modelValue.includes(props.value)
          : Boolean(props.modelValue)
    )
    const onChange = (event: Event) => {
      const isChecked = (event.target as HTMLInputElement).checked
      if (group) group.toggle(props.value, isChecked)
      else {
        const next = Array.isArray(props.modelValue)
          ? isChecked
            ? [...props.modelValue, props.value]
            : props.modelValue.filter((item) => item !== props.value)
          : isChecked
        emit('update:modelValue', next)
        emit('input', next)
        emit('change', next)
      }
    }
    return { group, checked, onChange, switchMode: props.switch }
  }
})
</script>
